import { VList } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,{attrs:{"dense":""}},[_vm._l((_vm.model),function(menuPair,index){return [(_vm.isAGrouper(menuPair.menu))?_c('drawer-group',{key:index,attrs:{"current-menu":_vm.activeMenu,"menu-pair":menuPair},on:{"update:active":_vm.handleUpdateActive}}):_c('drawer-link',{key:index,attrs:{"menu":menuPair.menu,"current-menu":_vm.activeMenu}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }